/**
 * @Description 宏观数据弹窗
 */

import { Modal } from 'antd';
import CitywideAnalyse from './CitywideAnalyse';

const MacroModal = ({ open, setOpen, macroData, name, level }) => {

  return (
    <Modal
      title='宏观数据'
      open={open}
      onCancel={() => setOpen(false)}
      width={860}
      footer={null}
    >
      <CitywideAnalyse data={macroData} name={name} level={level} />
    </Modal>
  );
};

export default MacroModal;
